import r from "./restArguments.js";
import t from "./isFunction.js";
import o from "./negate.js";
import m from "./map.js";
import i from "./_flatten.js";
import n from "./contains.js";
import s from "./pick.js";
var f = r(function (r, f) {
  var e,
    p = f[0];
  return t(p) ? (p = o(p), f.length > 1 && (e = f[1])) : (f = m(i(f, !1, !1), String), p = function p(r, t) {
    return !n(f, t);
  }), s(r, p, e);
});
export { f as default };